import {assert} from 'Asserts';
import {DataModificationsHeader} from 'audit/DataModifications';
import {EntryVersion, FromServerId, ServerEntryVersion, ToServerId} from 'notebook/ELNConstants';
import * as net from 'util/Net';
import {
  InputTableConfig,
  StageEntryDetails,
  StageEntryDocument,
  StageEntrySummary,
  StageRun,
} from 'workflows/WorkflowConstants';

export function get(id: string): JQueryPromise<StageEntryDocument> {
  return net.getJSON(`/1/api/workflows/stage-entries/${id}`);
}

export function bulkFetchSummaries(
  stageEntryIds: Array<string>
): Promise<{[stageEntryId: string]: StageEntrySummary}> {
  return net.postJSONPromise({
    url: '/1/api/workflows/stage-entries:bulk-get-summaries',
    data: {stageEntryIds},
  });
}

// TODO(TypeScript): figure out entry patcher types
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
type StageEntryUpdateResponse = any;

export function update(
  id: string,
  data: {
    name: string;
    entryVersion?: ServerEntryVersion<ToServerId>;
    metadata?: {
      latestVersionId: number;
      clientId: string;
      action: string | null;
    };
  },
  dataModsHeaders?: DataModificationsHeader
): JQueryPromise<StageEntryUpdateResponse> {
  return net.patchJSON({url: `/1/api/workflows/stage-entries/${id}`, data, extraHeaders: dataModsHeaders});
}

export function updateInputTableConfig(
  stageEntryId: string,
  {sortByType, sortByExperimentalConditionId, isSortReversed}: InputTableConfig
): JQueryPromise<{stageEntry: StageEntryDocument}> {
  return net.postJSON({
    url: `/1/api/workflows/stage-entries/update-input-table-config`,
    data: {
      stageEntryId,
      sortByType,
      sortByExperimentalConditionId,
      isSortReversed,
    },
  });
}

export function getWithEntryVersion(id: string): JQueryPromise<{
  stageEntryDetails: StageEntryDetails;
  entryVersion: ServerEntryVersion<FromServerId>;
}> {
  return net.getJSON(`/1/api/workflows/stage-entries/${id}/details`);
}

export function getVersions(
  id: string,
  param?: {openVersionId?: number}
): JQueryPromise<{data: Array<EntryVersion>}> {
  if (param == null) {
    param = {};
  }
  const {openVersionId} = param;
  // @ts-expect-error
  assert(!Number.isNaN(parseFloat(openVersionId || '')), `Entry id ${openVersionId} must be a number`);
  return net.getJSON(`/1/api/workflows/stage-entries/${id}/versions/`, {openVersionId});
}

export function getVersion(id: string, versionId: number): JQueryPromise<EntryVersion> {
  return net.getJSON(`/1/api/workflows/stage-entries/${id}/versions/${versionId}`);
}

export function fetchInputDataForChildrenRuns(stageEntryId: string): JQueryPromise<{
  affectedStageRuns: Array<StageRun>;
}> {
  return net.getJSON(`/1/api/workflows/stage-entries/${stageEntryId}:get-input-data-for-children-runs`);
}
